import { Link, Route, Routes, useLocation } from "react-router-dom";
import usePageTitle from '@/hooks/use-page-title';
import { ChevronRight } from 'lucide-react';
import ChangeInformations from "@/pages/profile/change-informations";
import MonProfil from "@/pages/profile/mon-profil";
import ChangeRib from "@/pages/profile/change-rib";
import ChangeAbonnements from "@/pages/profile/change-abonnements";
import ChangeMotDePasse from "@/pages/profile/change-mot-de-passe";
import ChangeInformationsNaissance from "@/pages/profile/change-informations-naissance";

const breadcrumbMap: Record<string, string | undefined> = {
    '/mon-profil/je-change-mes-informations-bancaires': 'Coordonnées bancaires',
    '/mon-profil/je-change-mes-informations': 'Informations de contact',
    '/mon-profil/je-change-mes-informations-de-naissance': 'Informations personnelles',
    '/mon-profil/je-change-mes-abonnements': 'Abonnements',
    '/mon-profil/je-change-mon-mot-de-passe': 'Mot de passe',
};

const Profile = () => {
    const location = useLocation();
    const currentPageName = breadcrumbMap[location.pathname];
    usePageTitle(currentPageName || 'Mon profil');

    return (
        <div className={'w-full'}>
            <nav className="flex items-center gap-1.5 text-xs sm:text-sm text-muted-foreground mt-4" aria-label="Fil d'Ariane">
                <Link to="/" className="hover:text-foreground transition-colors no-underline">Mon espace</Link>
                <ChevronRight className="w-3.5 h-3.5" />
                {currentPageName ? (
                    <>
                        <Link to="/mon-profil" className="hover:text-foreground transition-colors no-underline">Mon compte</Link>
                        <ChevronRight className="w-3.5 h-3.5" />
                        <span className="text-foreground font-medium">{currentPageName}</span>
                    </>
                ) : (
                    <span className="text-foreground font-medium">Mon compte</span>
                )}
            </nav>

            <Routes>
                <Route path={'/je-change-mes-informations-bancaires'} element={<ChangeRib />} />
                <Route path={'/je-change-mes-informations'} element={<ChangeInformations />} />
                <Route path={'/je-change-mes-informations-de-naissance'} element={<ChangeInformationsNaissance />} />
                <Route path={'/je-change-mes-abonnements'} element={<ChangeAbonnements />} />
                <Route path={'/je-change-mon-mot-de-passe'} element={<ChangeMotDePasse />} />
                <Route index element={<MonProfil />} />
            </Routes>

        </div>
    );
};


export default Profile;
